import React from 'react';
import './Header.scss';
import { ReactComponent as SvgLogo } from './logo.svg';

const Header = () => {

    return (
        <header className="header">
            <div className="container">
                <a href="https://www.geozilla.com/" className="header__logo">
                    <SvgLogo />
                </a>
            </div>
        </header>
    )
};

export default Header